import { useState, useEffect } from 'react'
import { X, Eye, Loader2 } from 'lucide-react'
import { previewEmail } from '../../services/api'
import toast from 'react-hot-toast'
import './EmailPreviewModal.css'

export default function EmailPreviewModal({ 
  isOpen, 
  onClose, 
  subject, 
  body, 
  recipient = null,
  includeSignature = true 
}) {
  const [preview, setPreview] = useState(null)
  const [loading, setLoading] = useState(false)
  const [testData, setTestData] = useState({
    firstName: recipient?.firstName || 'Jean',
    lastName: recipient?.lastName || 'Dupont',
    company: recipient?.company || 'Entreprise SAS',
    position: recipient?.position || 'Directeur',
    email: recipient?.email || 'jean.dupont@example.com'
  })

  useEffect(() => {
    if (isOpen && subject && body) {
      fetchPreview()
    }
  }, [isOpen, subject, body, testData, includeSignature])

  const fetchPreview = async () => {
    setLoading(true)
    try {
      const result = await previewEmail(subject, body, testData, includeSignature)
      if (result.success) {
        setPreview(result.preview)
      }
    } catch (error) {
      console.error('Preview error:', error)
      toast.error('Erreur lors de la prévisualisation')
    } finally {
      setLoading(false)
    }
  }

  if (!isOpen) return null

  return (
    <div className="epm-overlay" onClick={onClose}>
      <div className="epm-modal" onClick={e => e.stopPropagation()}>
        
        {/* Header */}
        <header className="epm-header">
          <div className="epm-title">
            <Eye size={18} />
            <span>Prévisualisation</span>
          </div>
          <button className="epm-close" onClick={onClose}>
            <X size={18} />
          </button>
        </header>

        {/* Test data inputs */}
        <div className="epm-test-bar">
          <input
            type="text"
            value={testData.firstName}
            onChange={e => setTestData(d => ({ ...d, firstName: e.target.value }))}
            placeholder="Prénom"
          />
          <input
            type="text"
            value={testData.lastName}
            onChange={e => setTestData(d => ({ ...d, lastName: e.target.value }))}
            placeholder="Nom"
          />
          <input
            type="text"
            value={testData.company}
            onChange={e => setTestData(d => ({ ...d, company: e.target.value }))}
            placeholder="Entreprise"
          />
          <input
            type="text"
            value={testData.position}
            onChange={e => setTestData(d => ({ ...d, position: e.target.value }))}
            placeholder="Poste"
          />
          <input
            type="email"
            value={testData.email}
            onChange={e => setTestData(d => ({ ...d, email: e.target.value }))}
            placeholder="Email"
          />
        </div>

        {/* Email preview */}
        <div className="epm-content">
          {loading ? (
            <div className="epm-loading">
              <Loader2 size={24} className="spinning" />
              <span>Chargement...</span>
            </div>
          ) : preview ? (
            <>
              <div className="epm-email-meta">
                <div className="epm-meta-row">
                  <span className="epm-label">De</span>
                  <span className="epm-value">{preview.from}</span>
                </div>
                <div className="epm-meta-row">
                  <span className="epm-label">À</span>
                  <span className="epm-value">{preview.to}</span>
                </div>
                <div className="epm-meta-row">
                  <span className="epm-label">Sujet</span>
                  <span className="epm-value epm-subject">{preview.subject}</span>
                </div>
              </div>
              <div className="epm-email-body">
                {preview.body}
              </div>
            </>
          ) : (
            <div className="epm-empty">
              Remplissez le sujet et le corps du message pour voir l'aperçu.
            </div>
          )}
        </div>

        {/* Footer */}
        <footer className="epm-footer">
          <button className="epm-btn" onClick={onClose}>Fermer</button>
        </footer>

      </div>
    </div>
  )
}
